import {
  Component,
  OnInit,
  Input,
  HostBinding,
  Attribute,
  Output,
  EventEmitter, OnChanges, SimpleChanges,
} from '@angular/core';

import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from "@angular/material/datepicker";

@Component({
  selector: 'mc-daterange',
  templateUrl: 'daterange.component.html',
  styleUrls: ['./daterange.component.scss'],
})

export class DaterangeComponent implements OnInit, OnChanges {
  @Input() readonly: boolean = false;

  @HostBinding('class')
  get classes(): string {
    return this.variant || 'normal';
  }

  @Input()
  maxDate: Date | undefined;

  @Input()
  minDate: Date | undefined;


  @Input()
  labelFrom: string = 'Dal';
  @Input()
  labelTo: string = 'Al';

  @Input() labelsOnLeft: boolean = false;

  @Input() fromDate: Date | undefined;
  @Input() toDate: Date | undefined;

  @Input() disabled: boolean = false;

  @Output() changeRange: EventEmitter<{
    startDate: Date | null;
    endDate: Date | null;
  }> = new EventEmitter<{ startDate: Date | null; endDate: Date | null }>();

  fromDateMinDate: Date | null = null;
  fromDateMaxDate: Date | null = null;

  toDateMinDate: Date | null = null;
  toDateMaxDate: Date | null = null;

  fromDateControl!: FormControl;
  toDateControl!: FormControl;

  /**
   * Why we used @Atrribute instead of @Input:
   * @link https://netbasal.com/getting-to-know-the-attribute-decorator-in-angular-4f7c9fb61243
   * @param variant - button Variant
   */
  constructor(
    @Attribute('variant')
    private variant: 'normal' | 'search' | 'dialog' = 'normal'
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fromDate'] && !changes['fromDate'].firstChange) {
      this.fromDateControl.setValue(this.fromDate);
    }
    if (changes['toDate'] && !changes['toDate'].firstChange) {
      this.toDateControl.setValue(this.toDate);
    }
  }

  ngOnInit(): void {

    this.fromDateControl = new FormControl(this.fromDate);
    this.toDateControl = new FormControl(this.toDate);
  }



  onChangeFromDate(fromDate: MatDatepickerInputEvent<Date, Date | null>) {
    this.toDateMinDate = fromDate.value;
    this.changeRange.emit({
      startDate: this.fromDateControl.value as Date,
      endDate: this.toDateControl.value as Date,
    });
  }
  onChangeToDate(toDate: MatDatepickerInputEvent<Date, Date | null>): void {
    this.fromDateMaxDate = toDate.value;
    this.changeRange.emit({
      startDate: this.fromDateControl.value as Date,
      endDate: this.toDateControl.value as Date,
    });
  }

}
